import { RETURN_PROCESSING_FLOW_RULES } from "@redotech/redo-model/return-flow/product-processing-spec";
import { ReturnProcessingDecisionState } from "@redotech/redo-return-ui/flows/return-flow/return-processing-decision";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

const DECISION_KEY_LABELS: Record<string, string> = {
  item_like_new: "Item like new",
  factory_sealed: "Factory sealed",
  new_condition: "New condition",
  item_wear: "Item wear",
  new_condition_after_cleaning: "New condition after cleaning",
};

export const ReturnProcessingDecisionDetails = memo(
  function ReturnProcessingDecisionDetails({
    stepSelect,
    state,
    setState,
  }: StepTypeDetailsProps<ReturnProcessingDecisionState>) {
    return (
      <Flex dir="column" gap="md">
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Prompt
          </Text>
          <RedoTextareaInputField
            placeholder="Question shown to the warehouse worker"
            setValue={(prompt) => setState((state) => ({ ...state, prompt }))}
            value={state.prompt}
          />
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Decision rule
          </Text>
          <SelectDropdown
            options={[...RETURN_PROCESSING_FLOW_RULES]}
            placeholder="Select a rule…"
            value={state.decisionKey || undefined}
            valueChange={(decisionKey) =>
              setState((state) => ({
                ...state,
                decisionKey: decisionKey ?? "",
              }))
            }
          >
            {(option) => DECISION_KEY_LABELS[option] ?? option}
          </SelectDropdown>
          <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
            Determines which built-in evaluator records the answer.
          </Text>
        </Flex>
        <Flex gap="sm">
          <Flex dir="column" gap="xs" style={{ flex: 1 }}>
            <Text fontSize="xs" fontWeight="medium" textColor="secondary">
              True label
            </Text>
            <RedoTextInput
              placeholder="Yes"
              setValue={(trueLabel) =>
                setState((state) => ({ ...state, trueLabel }))
              }
              value={state.trueLabel}
            />
          </Flex>
          <Flex dir="column" gap="xs" style={{ flex: 1 }}>
            <Text fontSize="xs" fontWeight="medium" textColor="secondary">
              False label
            </Text>
            <RedoTextInput
              placeholder="No"
              setValue={(falseLabel) =>
                setState((state) => ({ ...state, falseLabel }))
              }
              value={state.falseLabel}
            />
          </Flex>
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            On true →
          </Text>
          {stepSelect({
            value: state.nextTrue,
            valueChange: (nextTrue) =>
              setState((state) => ({ ...state, nextTrue })),
            handleIndex: 0,
          })}
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            On false →
          </Text>
          {stepSelect({
            value: state.nextFalse,
            valueChange: (nextFalse) =>
              setState((state) => ({ ...state, nextFalse })),
            handleIndex: 1,
          })}
        </Flex>
      </Flex>
    );
  },
);
